<template>
  <div class="container mx-auto py-4" style="direction: rtl; text-align: right">
    <check-status></check-status>
  </div>
</template>

<script>
import CheckStatus from "./components/checkStatus.vue";

export default {
  name: "App",
  components: {
    CheckStatus,
  },
};
</script>

